import { FieldType, MagazineNewspaperPublicationField, RowType } from '../../../../components/GenericSection';
import { END, START } from '../../../constants';
export var MAGAZINE_PUB_SECTION_FIELDS = [{
  type: FieldType.TEXT,
  labelText: 'Magazine title',
  recommended: false,
  field: MagazineNewspaperPublicationField.TITLE
}, {
  rowtype: RowType.SM_TWO_ROW,
  fields: [{
    field: MagazineNewspaperPublicationField.VOLUME,
    labelText: 'Volume',
    recommended: false,
    type: FieldType.TEXT
  }, {
    field: MagazineNewspaperPublicationField.ISSUE,
    labelText: 'Issue',
    recommended: false,
    type: FieldType.TEXT
  }]
}, {
  field: MagazineNewspaperPublicationField.PUBLISHED_DATE,
  type: FieldType.PUBDATE,
  labelText: 'Date published',
  formikFieldNames: ['day', 'month', 'year']
}, {
  fields: [{
    field: MagazineNewspaperPublicationField.START_PAGE,
    labelText: START,
    type: FieldType.TEXT
  }, {
    field: MagazineNewspaperPublicationField.END_PAGE,
    labelText: END,
    type: FieldType.TEXT
  }]
}, {
  field: MagazineNewspaperPublicationField.NON_CONSECUTIVE,
  labelText: 'Pages are nonconsecutive',
  type: FieldType.CHECKBOX
}];
export var NEWSPAPER_PUB_SECTION_FIELDS = [{
  type: FieldType.TEXT,
  labelText: 'Newspaper title',
  recommended: false,
  field: MagazineNewspaperPublicationField.TITLE
}, {
  field: MagazineNewspaperPublicationField.CITY,
  labelText: 'City',
  recommended: false,
  helperText: 'Only include if city is not in newspaper name',
  type: FieldType.TEXT
}, {
  rowtype: RowType.SM_TWO_ROW,
  fields: [{
    field: MagazineNewspaperPublicationField.EDITION,
    labelText: 'Edition',
    recommended: false,
    type: FieldType.TEXT
  }, {
    field: MagazineNewspaperPublicationField.SECTION,
    labelText: 'Section',
    recommended: false,
    type: FieldType.TEXT
  }]
}, {
  field: MagazineNewspaperPublicationField.PUBLISHED_DATE,
  type: FieldType.PUBDATE,
  labelText: 'Date published',
  formikFieldNames: ['day', 'month', 'year']
}, {
  fields: [{
    field: MagazineNewspaperPublicationField.START_PAGE,
    labelText: START,
    type: FieldType.TEXT
  }, {
    field: MagazineNewspaperPublicationField.END_PAGE,
    labelText: END,
    type: FieldType.TEXT
  }]
}, {
  field: MagazineNewspaperPublicationField.NON_CONSECUTIVE,
  labelText: 'Pages are nonconsecutive',
  type: FieldType.CHECKBOX
}];